import React, { useEffect, useState } from 'react';
import MainLayout from '../../../layout/mainLayout';
import {
  Typography,
  Grid,
  Button,
  FormControl,
  FormHelperText,
} from '@mui/material';
import ApiClient from '../../../config/api';
import InputBox from '../../../components/inputBox';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSnackBar } from '../../../store/globalSlice';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const ChangePassword = () => {
  const api = ApiClient();
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState('');
  const [error, setError] = useState({ field: '', message: '' });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const phoneNumber = JSON.parse(localStorage.getItem('info'))?.mobile_no || '';
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [resendCooldown, setResendCooldown] = useState(0);

  const onSubmit = async () => {
    if (!password) {
      setError({ field: 1, message: 'لطفا رمز عبور را وارد نمایید' });
    } else if (password !== confirmPassword) {
      setError({ field: 2, message: 'رمز عبور با تکرار آن تطابق ندارد' });
    } else if (!otp) {
      setError({ field: 3, message: 'لطفا کد تایید را وارد نمایید' });
    } else {
      try {
        setIsLoading(true);
        const response = await api.post(`/api/app/v1/auth/verify-otp`, {
          code: otp,
          temp_token: token,
          new_password: password,
          new_password_confirm: confirmPassword,
        });
        dispatch(
          setSnackBar({
            message: 'رمز عبور با موفقیت تغییر یافت',
            severity: 'success',
          })
        );
        navigate('/profile', { replace: true });
      } catch (error) {
        dispatch(
          setSnackBar({ message: error?.response?.message, severity: 'error' })
        );
      } finally {
        setIsLoading(false);
      }
    }
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const response = await api.post(`/api/app/v1/auth/otp`, {
        mobile_no: phoneNumber,
        otp_type: 'forgot_password',
      });
      setToken(response?.data?.temp_token);

      setResendCooldown(120);
    } catch (error) {
      setError({ field: 0, message: error?.response?.message });
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeOtp = (newValue) => {
    setOtp(newValue);
  };
  const handleChangePassword = (newValue) => {
    setPassword(newValue);
  };
  const handleChangeConfirmPassword = (newValue) => {
    setConfirmPassword(newValue);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    let timer;
    if (resendCooldown > 0) {
      timer = setInterval(() => {
        setResendCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [resendCooldown]);

  return (
    <MainLayout>
      <Grid
        paddingRight={'20px'}
        paddingLeft={'20px'}
        marginTop={'20px'}
        container
        justifyContent={'space-between'}
      >
        <Grid item display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <KeyboardBackspaceIcon
            className={'clickable'}
            sx={{
              transform: 'rotate(180deg)',
              cursor: 'pointer',
              marginRight: '8px',
              fontSize: '24px',
            }}
            onClick={() => {
              navigate('/profile', { replace: true });
            }}
          />
          <Typography fontSize={20} fontWeight={600}>
            تغییر رمز عبور
          </Typography>
        </Grid>
      </Grid>
      <Grid
        paddingRight={'20px'}
        paddingLeft={'20px'}
        marginTop={'32px'}
        container
        flexDirection={'column'}
      >
        <Grid item>
          <InputBox
            label="شماره موبایل"
            value={phoneNumber}
            isLoading={true}
            type="number"
            icon={null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="کلمه عبور"
            value={password}
            setValue={handleChangePassword}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="password"
            icon={null}
            error={error?.field == 1 ? error?.message : null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="تکرار کلمه عبور"
            value={confirmPassword}
            setValue={handleChangeConfirmPassword}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="password"
            icon={null}
            error={error?.field == 2 ? error?.message : null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="کد تایید"
            value={otp}
            setValue={handleChangeOtp}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="number"
            icon={null}
            error={error?.field == 3 ? error?.message : null}
          />
        </Grid>
        <Grid item justifyContent={'flex-start'} display={'flex'}>
          {resendCooldown === 0 ? (
            <Typography
              onClick={() => {
                if (resendCooldown === 0) {
                  getData();
                  dispatch(
                    setSnackBar({
                      message: 'رمز یکبار مصرف برای شما ارسال شد',
                      severity: 'success',
                    })
                  );
                }
              }}
              sx={{
                marginLeft: '5px',
                fontWeight: 600,
                textDecoration: isLoading ? 'none' : 'underline',
              }}
              color={isLoading ? '#A1A1AA' : '#000000'}
              className={isLoading ? '' : 'clickable'}
            >
              ارسال کد
            </Typography>
          ) : (
            <Typography
              color={'#A1A1AA'}
            >{`ارسال دوباره کد (${resendCooldown} ثانیه)`}</Typography>
          )}
        </Grid>
        <Grid item>
          <FormControl
            size="small"
            variant="standard"
            fullWidth
            error={Boolean(error?.field)}
          >
            {error?.field == 0 && (
              <FormHelperText>{error?.message}</FormHelperText>
            )}
          </FormControl>
          <Button
            onClick={onSubmit}
            disabled={isLoading}
            sx={{
              marginTop: '24px',
              width: '100%',
              height: '57px',
              borderRadius: '8px',
              color: 'primary.contrastText',
              fontFamily: 'iran-sans-light',
              fontSize: '16px',
              fontWeight: '600',
              marginTop: '0px',
            }}
            size="large"
            variant="contained"
          >
            {isLoading ? <CircularProgress size={24} sx={{ color: 'primary.contrastText' }} /> : 'تایید و ادامه'}
          </Button>
        </Grid>
      </Grid>
    </MainLayout>
  );
};

export default ChangePassword;
